//---------------------------------
// get specific rune casting skill
//---------------------------------
export default function getSpecificRuneCastingSkill({ skills, target_rune }) {
  if (!skills || !target_rune) {
    console.error('getSpecificRuneCastingSkill: missing required parms')
    return 0
  }

  return skills.find((s) => s.name == 'Runecasting' && s.display_name == target_rune.name)
}
